const Lang = require('lang');

function AutoSelectAttributesFromReport($idDespesa) {
  if ($idDespesa.prop('id') !== 'idDespesa') {
    throw new Error(Lang.get('js/src/functions/selectCostCenterIfExists.not_report_selector'));
  }

  const $form = $idDespesa.closest('form');
  const $idEmpresaPagante = $form.find('#idEmpresaPagante');
  const $idPagamentoForma = $form.find('[name=idPagamentoForma]');
  const idEmpresaPaganteSelectize = $idEmpresaPagante[0].selectize;
  const idPagamentoFormaSelectize = $idPagamentoForma[0].selectize;
  const idDespesaSelectize = $idDespesa[0].selectize;

  $idDespesa.on('change', function () {
    if (!idDespesaSelectize.getValue()) {
      return;
    }

    const url = route('app.relatorios.show-json', { id: idDespesaSelectize.getValue() });
    idEmpresaPaganteSelectize.disable();
    idPagamentoFormaSelectize.disable();
    idDespesaSelectize.disable();
    $.get(url)
      .always(function (response) {
        const relatorioProjeto = response.relatorio_projeto;
        const cardsPaymentId = $form[0].dataset.cardsPaymentMethod;

        // Medida temporaria para tratar caso um relatório seja criado pela v2 e não tenha centro de custo
        if (!!response.centro_custos) {

          idEmpresaPaganteSelectize.clearOptions();
          idEmpresaPaganteSelectize.addOption({
            value: response.idEmpresaPagante,
            text: response.centro_custos.nome
          });

          idEmpresaPaganteSelectize.setValue(response.idEmpresaPagante);

          // Verificando se está utilzando aprovação
          // por centro de custo
          if (isApprovalByCostCenter($idEmpresaPagante)) {
            idEmpresaPaganteSelectize.disable();
            toggleRuleRequiredCostCenter($idEmpresaPagante, false);
            toggleDizableCostCenterToSendData($idEmpresaPagante, false);
          } else {
            idEmpresaPaganteSelectize.enable();
          }

        } else {
          idEmpresaPaganteSelectize.enable();
        }

        idDespesaSelectize.enable();

        // Modifcando a forma de pagamento do item de despesa para
        // a forma sugerida no relatório, apenas se o item de despesa
        // não estiver conciliado
        if ($form[0].dataset.expenseConciliated === undefined
          && $form[0].dataset.expenseImported === undefined
          && (cardsPaymentId === undefined || idPagamentoFormaSelectize.getValue() !== cardsPaymentId)
        ) {
          idPagamentoFormaSelectize.clear(true);
          idPagamentoFormaSelectize.addItem(response.idPagamentoForma);
          idPagamentoFormaSelectize.enable();
        }

        // Se o se o projeto de sugestão não indefinido,
        // ou se estiver em uma tela de edição de despesa,
        // não realiza a sugestão do projetorelatorioProjeto
        if ($form[0].classList.contains('ignore-suggestion-project')
          || relatorioProjeto === undefined) {
          return;
        }
        checkExistsRateio($form, $idDespesa, relatorioProjeto);
      });
  });

}

/**
 * Validação de qual tipo de operação está sendo realizada
 * para executar o modal de confirmação da alteração
 *
 * @param  {element} $form
 * @param  {element} $idDespesa
 * @param  {object} relatorioProjeto
 */
function checkExistsRateio($form, $idDespesa, relatorioProjeto) {
  const $rateios = $form.find('#despesas-container .rateio');
  // const $inputProjeto = $form.find('#despesas-container .idEmpresaReembolsante');
  // const idProjetoSelecionado = $inputProjeto.val();
  // const novoProjetoAttribute = $idDespesa.data('data-new-project');

  // Se houver sugestão de projeto
  if (relatorioProjeto.length) {
    // Se o valor do atributo do novo projeto for diferente do
    // valor recebido na sugestão do relatório, muda o valor do atributo
    // para conter o valor do projeto de sugestão
    // if (novoProjetoAttribute != relatorioProjeto[0].idProjeto) {
    //   $idDespesa.data('data-new-project', relatorioProjeto[0].idProjeto);
    // }

    // Verifica se o rateio é obrigatório
    const rateioRequired = $form.find('#novosRateios').data('rateioRequired');

    // CASOS QUE NÃO EXISTEM RATEIOS E TEMOS SUGESTAO DE PROJETO
    // Se não existir rateios, exibe o container de
    // rateios com a input de projeto preenchida de acordo com
    // sugestão do relatório
    if ($rateios.length == 0 || rateioRequired) {
      showContainerProjeto($form, $idDespesa);
      selectProjeto($form, relatorioProjeto);
      return;
    }

    // CASOS QUE EXISTE MAIS DE UM RATEIO E TEMOS SUGESTAO DE PROJETO
    // Se existir mais de um rateios e o valor do atributo de novo
    // projeto for diferente do projeto recebido como sugestão,
    //  é chama o modal de confirmação para decidir se o usuário
    //  quer alterar os rateios existente ou não
    // if ($rateios.length > 1
    //  && novoProjetoAttribute != relatorioProjeto[0].idProjeto) {
    //  const msg = Lang.get('js/src/functions/AutoSelectAttributesFromReport.has_many_apportionments');
    //  openModalConfirmation($form, $idDespesa, relatorioProjeto, msg);
    //  return;
    // }

    // CASOS QUE EXISTE APENAS UM RATEIO E TEMOS SUGESTAO DE PROJETO
    // Se o valor do atributo de novo projeto for diferente do projeto recebido
    // como sugestão chama o modal de confirmação, para identificar se ele será
    // alterado ou não
    // if (novoProjetoAttribute != relatorioProjeto[0].idProjeto) {
    //  const msg = Lang.get('js/src/functions/AutoSelectAttributesFromReport.has_apportionment');
    //  openModalConfirmation($form, $idDespesa, relatorioProjeto, msg);
    //}
    return;
  }

  // CASOS QUE NÃO TEMOS SUGESTAO DE PROJETO
  // if (novoProjetoAttribute != 'null' && $rateios.length > 0) {
  //  $idDespesa.data('data-new-project', 'null');
  //  const msg = Lang.get('js/src/functions/AutoSelectAttributesFromReport.has_apportionments_not_has_suggestion');
  //  openModalConfirmation($form, $idDespesa, relatorioProjeto, msg, true);
  // }
}

/**
 * Abrir o modal para confirmar se o usuário deseja
 * alterar os rateios existentes na tela
 *
 * @param  {element}  $form
 * @param  {element}  $idDespesa
 * @param  {object}  relatorioProjeto
 * @param  {string}  msg
 * @param  {Boolean} removeAll
 */
function openModalConfirmation($form, $idDespesa, relatorioProjeto, msg, removeAll = false) {
  bootbox.confirm({
    title: Lang.get('js/src/functions/AutoSelectAttributesFromReport.title_change_apportionments'),
    message: msg,
    size: 'small',
    callback: function (confirmed) {
      if (confirmed) {
        // Apenas remover projetos
        if (removeAll) {
          hideContainerProjeto($form);
          return;
        }
        // Remover projetos e adicionar rateios
        hideContainerProjeto($form);
        showContainerProjeto($form, $idDespesa);
        selectProjeto($form, relatorioProjeto);
      }
    }
  });
}
/**
 * Exibir o container com as inputs de rateio,
 *
 * @param  {element} $form
 * @param  {int} $idDespesa
 */
function showContainerProjeto($form, $idDespesa) {
  const $buttonAddProject = $form.find('#novosRateios button');
  const $rateios = $form.find('#despesas-container .rateio');

  // Limitando a adição de apenas uma input,
  // para inpedir que uma nova input seja adicionado se
  // o usuário trocar de relatório
  if (!$rateios.length >= 1) {
    $buttonAddProject.click();
  }
}

/**
 * Remover o container da inputs de rateio, retirando
 * as entradas do formulário
 *
 * @param  {element} $form
 */
function hideContainerProjeto($form) {
  const $buttonAddProject = $form.find('#despesas-container #novosRateios');
  const $rateios = $form.find('#despesas-container .rateio');

  $buttonAddProject.show();
  $rateios.remove();
}

/**
 * Selectionar o projeto ligado ao relatório como sugestão
 * dentro da primeira input de rateio
 *
 * @param  {element} $form
 * @param  {array} relatorioProjeto
 */
function selectProjeto($form, relatorioProjeto) {
  const $inputProjeto = $form.find('#despesas-container .idEmpresaReembolsante');
  const idProjetoSelectize = $inputProjeto[0].selectize;
  idProjetoSelectize.disable();
  idProjetoSelectize.clearOptions();
  idProjetoSelectize.addOption({
    value: relatorioProjeto[0].idProjeto,
    text: relatorioProjeto[0].empresa.nome
  });
  idProjetoSelectize.setValue(relatorioProjeto[0].idProjeto);
  idProjetoSelectize.enable();
}

/**
 * Verificar se o tipo de apravação é por centro
 * de custo
 *
 * @param  {Element}  $idEmpresaPagante
 *
 * @return {Boolean}
 */
function isApprovalByCostCenter($idEmpresaPagante) {
  const approvalType = $idEmpresaPagante[0].getAttribute('data-approval-type');
  if (approvalType == 'CC') {
    return true;
  }
  return false;
}

/**
 * Adicionar ou remover a regra de requerido no
 * select box de centro de custo
 *
 * @param  {Element} $idEmpresaPagante
 * @param  {Boolean} value
 */
function toggleRuleRequiredCostCenter($idEmpresaPagante, value) {
  $idEmpresaPagante[0].setAttribute('data-rule-required', value);
}

/**
 * Adicionar ou remover a propriedade dizabled do
 * select box de centro de custo
 *
 * @param  {Element} $idEmpresaPagante
 * @param  {Boolean} value
 */
function toggleDizableCostCenterToSendData($idEmpresaPagante, value) {
  $idEmpresaPagante[0].disabled = value;
}



/**
 * Adiciona listener ao abrir todos os modais da pagina de relatórios e despesa.
 * Remove ou desabilita a forma de pagamento de cartão.
 */
function addListenerShowModal() {
  const $modals = $('#modal-despesa, #modal-percurso, #modal-mapa-percurso');

  $modals.on('shown.bs.modal', function (e) {
    const $form = $(this).find('form');
    const $idPagamentoForma = $form.find('[name=idPagamentoForma]');
    const idPagamentoFormaSelectize = $idPagamentoForma[0].selectize;

    const cardsPaymentId = $form[0].dataset.cardsPaymentMethod;
    if (cardsPaymentId !== undefined) {
      if (idPagamentoFormaSelectize.getValue() === cardsPaymentId) {
        idPagamentoFormaSelectize.disable();
      } else {
        idPagamentoFormaSelectize.removeOption(cardsPaymentId);
      }
    }
  })
}

module.exports = {
  init: function init() {
    const $idDespesa = $('#percurso #idDespesa, #despesa #idDespesa, #modal-percurso #idDespesa, #modal-despesa #idDespesa, #form-mapa-percurso #idDespesa');
    $idDespesa.each(function (n, idDespesa) {
      AutoSelectAttributesFromReport($(idDespesa));
    });
    addListenerShowModal();
  }
};
